<template>
	<div id="main-container" class="d-md-flex justify-content-center">
		<b-overlay
			id="overlay-coi-list-card"
			:show="queryInProgress"
			variant="light"
			opacity="0.5"
			blur="2px"
			rounded="lg"
		><!-- overlay -->
			<b-card class=" mx-3 mt-1">
				<div class="row" id="coi-pagination">
					<div class="col-md-2">
						<div class="d-flex justify-content-start pt-3">
							<h3 pt-3>Kernübersicht</h3>
						</div>
					</div>
					<div class="col-md-10">
						<div class="d-flex flex-row justify-content-end">
							<div class="d-flex flex-row-reverse">
								<div class="py-2">
									<b-form-select
										id="per-page-select"
										v-model="perPage"
										:options="pageOptions"
										size="md"
									></b-form-select>
								</div>
								<div class="p-2">
									<b-pagination
										v-if="jobs"
										id="table-pagination-job-schedule"
										class="float-right"
										v-model="currentPage"
										:total-rows="jobs.filter(filterFunction).length"
										:per-page="perPage"
										aria-controls="table-job-schedule"
									></b-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>

				<b-table
					class="mt-3"
					:items="filteredJobs"
					:fields="fields"
					:tbody-tr-class="jobRowClass"
					:per-page="perPage"
					:current-page="currentPage"
					:filter-function="filterFunction"
					small
					hover
				><!-- b-table -->
					<template v-slot:cell(currentState)="job">
						<div v-if="job.item.currentState == 0">0 ⚪</div>
						<div v-else-if="job.item.currentState == 1">1 🟢</div>
						<div v-else>{{ job.item.currentState }} 🟡</div>
					</template>
					<template v-slot:cell(className)="job">
						<div>
							{{ job.item.className }}
							<b-badge
								variant="info"
								v-if="'_D' === job.item.className.substr(job.item.className.length - 2, 2)"
							>DEV</b-badge>
							<b-badge
								variant="warning"
								v-if="'C2_' === job.item.className.substr(0, 3)"
							>C++</b-badge>
						</div>
					</template>
					<template v-slot:cell(name)="job">
						<div v-if="'[OFF]' !== job.item.name.substr(0, 5)">
							<span>{{ job.item.name }}</span>
						</div>
						<div v-else>
							<b-badge variant="danger">[OFF]</b-badge>
							<span>{{ job.item.name.substr(5, job.item.name.length) }}</span>
						</div>
					</template>
					<template v-slot:cell(nextRun)="job">
						{{ moment(job.item.nextRun).format('DD.MM.YYYY HH:mm') }}
					</template>

					<template v-slot:cell(action)="job">
						<b-button
							v-if="job.item.restartable"
							size="sm"
							variant="primary"
							@click="restartJob(job.item)"
						><!-- button -->
							<span class="icon icon-loop"/>
						</b-button>
					</template>

					<!-- <template v-slot:cell(lastUpdateTime)="job">
						{{ getTimeDiff(job.item.lastUpdateTime) }}
					</template> -->

				</b-table>
			</b-card>
			<div v-for="slave in slaves" :key="slave.slaveName">
				<core-process-slave-component :slaveName="slave.slaveName" :slaveUrl="slave.slaveUrl" />
			</div>
		</b-overlay>
	</div>
</template>
<style scoped>
	.link2 {
		color: #131313 !important;
	}
    .link2:hover {
        color: #25bf43 !important;
		cursor: pointer;
    }
</style>
<script>
import CoreProcessSlaveComponent from './CoreProcessSlaveComponent.vue';
export default {
	components: {CoreProcessSlaveComponent },
	props: [ /*🔴🟠🟡🟢🔵🟣⚫⚪🟤*/ ],
	data() {
		return {
          slaves: []
		  , isMaster: false
		  , queryInProgress: false
		  , refreshDelayInSeconds: 90
		  , auth: null
		  , jobs: []
		  , pids: []
		  , perPage: 1000
		  , currentPage: 1
		  , pageOptions: [25, 100, 250, 1000]
		  , tHeight: this.window.innerHeight - 75
        , fastFilterStrings: [ 'Fulfillment', 'Vendor Import', 'Lager', '\\[OFF\\]', 'Delivery Note' ]
		};
	},computed:{

		filteredJobs: function() {
			if(!this.jobs) return [];
			let ret = this.jobs.filter( job => ((job.pid) || ((1 == job.currentState) && job.currentNode)) );
			return ret.map( job => {
				job.restartable = (!job.pid) || (!this.pids.includes(job.pid));
				return job;
			});
        }

		, fields: function() {
			let f = [
			  { key: "name", label: "Titel", sortable: true, /* tdClass: 'table-danger' */ },
        { key: "className", label: "className", sortable: true },
        { key: "nextRun", label: "Geplante Startzeit", sortable: true },
        { key: "pid", label: "PID", sortable: true },
        { key: "action", label: "", sortable: false },
        { key: "lastUpdateTime", label: "Update", sortable: true },
        { key: "currentState", label: "Status", sortable: true },
			];
			return f;
		}

	},methods: {

		restartJob(job) {
			this.queryInProgress = true;
			Promise.all([
				axios.get(`/jobschedule/restartjob/${job.id}`)
			  , new Promise( r => setTimeout(r, 250))
			]).then( () => {
				this.queryInProgress = false;
				this.fetchData();
			}).catch( error => {
				alert(`der job \"${job.name}\" konnte nicht neugestartet werden.`);
				console.error(error);
				this.queryInProgress = false;
			});
		},

		jobRowClass(job, type) {
			return (job.restartable) ? 'table-danger' : '';
		}

		,fastFilter(str) {
			this.query.name = str;
			this.submit();
		}

		,filterFunction(job) {
			return (1 == job.state) && (job.currentNode);
		}

		,fetchData() {
			this.queryInProgress = true;
			return new Promise((resolve, reject) => {
				Promise.all([
					axios.get("jobschedule/bycurrentstate/1")
				 , axios.get("/coreprocess/get_process_list")
				 , new Promise( r => setTimeout(r, 750))]
				).then( ([_jobs, _processList]) => {						
					this.pids = _processList.data.process_list.split('\n').map( row => Number(row.split(';')[1]) );
					//check if we are master, if so we need to get slave data as well...
					this.isMaster = ["Master", "Developer"].includes(_processList.data.instance_type);
					if(this.isMaster) {
						axios.get("/coreprocess/get_slave_process_lists").then( resp => {
							this.slaves = [];
							for(const name of Object.keys(resp.data)) {
								this.slaves.push({slaveName: name, slaveUrl: resp.data[name] });
							}
						}).catch( error => {
							alert("Die Prozesse von den Slave Servern (Coseon, WR, LDD) konnten nicht geholt werden.");
							console.error(error);
						});
					}
					this.jobs = _jobs.data;
					this.queryInProgress = false;
					resolve();
				}).catch( error => {
					alert("konnte jobs nicht vom Server holen.");
					this.queryInProgress = false;
					console.error(error);
					reject(error);
				});
			});

		}

		,fetchDataLoop() {
			this.fetchData().then( () => setTimeout( this.fetchDataLoop, this.refreshDelayInSeconds * 1000) );
		}

	}, created() {
		Promise.all([
			axios.get('/user/authorization')
		  , this.fetchData()
		]).then( ([response, crap]) => {
			this.auth = response.data;
			this.fetchDataLoop();
		}).catch( error => {
			alert("Daten konnten nicht runtergeladen werden.");
			console.error(error);
		});
	}
};
</script>

